import { Routes } from '~/modules/routes';
import { navigate } from '~/modules/stores/routerStore';
import { ERROR_CODES } from '~/modules/utilities/error_utilities';
import { logger } from './logger';

export function notFoundError(context?: string) {
    logger.error(`Not found error${context ? `: ${context}` : ''}`);
    navigate(`${Routes.ERROR}?code=${ERROR_CODES.PAGE_NOT_FOUND}`);
}

export function missingQueryParamError(context?: string) {
    logger.error(`Missing query param error${context ? `: ${context}` : ''}`);
    navigate(`${Routes.ERROR}?code=${ERROR_CODES.MISSING_QUERY_PARAM}`);
}

export function invalidQueryParamError(context?: string) {
    logger.error(`Invalid query param error${context ? `: ${context}` : ''}`);
    navigate(`${Routes.ERROR}?code=${ERROR_CODES.INVALID_QUERY_PARAM}`);
}

export function missingListingError(context?: string) {
    logger.error(`Missing listing error${context ? `: ${context}` : ''}`);
    navigate(`${Routes.ERROR}?code=${ERROR_CODES.MISSING_LISTING}`);
}

// This utility is meant to help test when your LWC element being added is supposed to throw an
// exception. This can be used to wrap the document.body.appendChild() call, returning the
// exception that took place.
// Source - https://github.com/salesforce/lwc/blob/v2.45.2/packages/%40lwc/integration-karma/helpers/test-utils.js#L296-L315
// @ts-expect-error * Automated Type Error Fix
export function windowErrorListener(callback) {
    let error;
    // @ts-expect-error * Automated Type Error Fix
    function onError(event) {
        event.preventDefault(); // don't log the error
        error = event.error;
    }

    const originalOnError = window.onerror;
    Object.defineProperty(window, 'onerror', { value: null, configurable: true });
    window.addEventListener('error', onError);

    try {
        callback();
    } finally {
        Object.defineProperty(window, 'onerror', { value: originalOnError, configurable: true });
        window.removeEventListener('error', onError);
    }
    return error;
}
